@use '../../scss/utility';

@use './link-vars';
@use './link-common';

:host {
  @include link-common.wb-link;
}

a {
  @include link-common.wb-link-inner;
  @include link-common.wb-link-prefers-reduced-motion;

  &:focus {
    @include link-common.wb-link-focus;
  }
}

:host([variant='inline']) {
  @include link-vars.wb-link-inline-vars;
}

:host([variant='inline']:hover) {
  @include link-vars.wb-link-inline-hover-vars;
}

:host([variant='inline']:focus) {
  @include link-vars.wb-link-inline-focus-vars;
}

:host([variant='inline']:active) {
  @include link-vars.wb-link-inline-active-vars;
}

:host([variant='standalone']) {
  @include link-vars.wb-link-standalone-vars;

  a {
    @include link-common.wb-link-standalone-type;
  }
}

:host([variant='small']) {
  @include link-vars.wb-link-standalone-vars;
  @include link-vars.wb-link-standalone-m-vars;

  a {
    @include link-common.wb-link-small-type;
  }
}

:host([variant='tiny']) {
  @include link-vars.wb-link-standalone-vars;
  @include link-vars.wb-link-standalone-s-vars;

  a {
    @include link-common.wb-link-tiny-type;
  }
}

:host([is-rtl]) a {
  @include link-common.wb-link-rtl;
}

:host(:hover) a,
:host(:focus-within) a {
  @include link-common.wb-link-hover-focus-within;
}

:host([variant='standalone']:hover),
:host([variant='small']:hover),
:host([variant='tiny']:hover) {
  @include link-vars.wb-link-standalone-hover-vars;
}

:host([variant='standalone']:focus-within),
:host([variant='small']:focus-within),
:host([variant='tiny']:focus-within) {
  @include link-vars.wb-link-standalone-focus-vars;
}

:host([variant='standalone']:active),
:host([variant='small']:active),
:host([variant='tiny']:active) {
  @include link-vars.wb-link-standalone-active-vars;
}

:host([variant='standalone'][size='s']) {
  @include link-vars.wb-link-standalone-s-vars;

  a {
    @include link-common.wb-link-size-small;
  }
}

:host([variant='standalone'][size='m']) {
  @include link-vars.wb-link-standalone-m-vars;

  a {
    @include link-common.wb-link-size-medium;
  }
}

:host([variant='standalone'][size='l']) {
  @include link-vars.wb-link-standalone-l-vars;

  a {
    @include link-common.wb-link-size-large;
  }
}

::slotted([slot='icon']) {
  @include link-common.wb-link-icon;
}

::slotted([slot='trail-icon']) {
  @include link-common.wb-link-trail-icon;
}
